$('.sidebarSubmitMarket').on('click', function (e) {
    e.preventDefault();
    // if (validateForm()) {
    submitForm();
    // }
});

function smsError() {
    const error_message = $('.account-sidebar__container[data-tab="marketing-preferences"] .error__signup');
    const error_content = error_message.find('.message').data('customer-must-provide-phone-for-sms-consent');
    return `<a href="#" class="btn--navigate" data-tab="personal-details">${error_content.replace('here', '<u>here</u>')}</a>`;
}

function validateForm() {
    const error_message = $('.account-sidebar__container[data-tab="marketing-preferences"] .error__signup');
    const smsCheckbox = document.getElementById('sidebar-sms');
    const smsInputValue = smsCheckbox.value;

    if (smsCheckbox.checked && (!smsInputValue || smsInputValue.trim() === '')) {
        error_message.find('.message').html(smsError());
        error_message.show();
        setTimeout(function () {
            error_message.fadeOut();
        }, 3000);
        return false;
    }

    error_message.hide();
    return true;
}

function submitForm() {
    const error_message = $('.account-sidebar__container[data-tab="marketing-preferences"] .error__signup');
    const success_message = $('.account-sidebar__container[data-tab="marketing-preferences"] .success__signup');
    const emailCheckbox = document.getElementById('sidebar-email');
    const smsCheckbox = document.getElementById('sidebar-sms');
    const formData = {
        consent: {
            sms: smsCheckbox.checked,
            email: emailCheckbox.checked
        }
    };

    $.ajax({
        type: 'POST',
        url: `/apps/bat-enhanced/newsletter/subscribe`,
        data: JSON.stringify(formData),
        contentType: 'application/json',
        success: function (response) {
            {/* - SMS consent provided but no phone is provided
                ok: false
                message: customer-must-provide-phone-for-sms-consent
            */}
            var selectOptionText = error_message.find('.message').data('customer-must-select-a-consent-option');
            var missingPhoneText = error_message.find('.message').data('customer-must-provide-phone-for-sms-consent');
            var failedText = error_message.find('.message').data('customer-setup-failed');

            if (response.ok === true) {
                error_message.hide();
                success_message.show();
                setTimeout(function () {
                    success_message.fadeOut();
                }, 3000);
            } else {
                var text = failedText;
                if (response.message == 'customer-must-select-a-consent-option') text = selectOptionText;
                if (response.message == 'customer-must-provide-phone-for-sms-consent') text = missingPhoneText;
                if (response.message == 'customer-must-provide-phone-for-sms-consent') {
                    error_message.find('.message').html(smsError());
                } else {
                    error_message.find('.message').text(text);
                }
                error_message.show();
                success_message.hide();
                setTimeout(function () {
                    error_message.fadeOut();
                }, 3000);
            }
        },
        error: function (error) {
            console.log("An error occurred:", error);
            error_message.find('.message').text(theme.strings.genericError);
            error_message.show();
            success_message.hide();
            setTimeout(function () {
                error_message.fadeOut();
            }, 3000);
        }
    });
}
